'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import SuiteCatalogModal from 'pricing-pages-unified-ui/components/crm-suite-catalog/SuiteCatalogModal';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getHubsSignupCTA } from 'pricing-pages-lib/utils/publicPageUrls';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { useValidatedCrmSuiteQueryParamTerm } from '../../utils/stateUtils';
import { ProductLevelToSuiteNonMerchandiseIdMap } from 'pricing-pages-lib/constants/NonMerchandiseIdProducts';
import { SUITE_CARD } from '../../constants/Tracking';

const SuiteViewAllFeatures = ({
  productLevel,
  currencyCode
}) => {
  const [isModalOpen, setIsModalOpen] = useState(productLevel === STARTER && getQueryParams().viewStarterFeatures === true);
  const gaClassName = getHubsSignupCTA({
    nonMerchandiseIdProduct: ProductLevelToSuiteNonMerchandiseIdMap[productLevel],
    sourceId: 'pricing-features'
  });

  const toggleViewAllFeaturesModal = () => {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      getUsageTracker().track('clickToViewModal', {
        name: 'compare-feature-modal',
        productLevel,
        location: SUITE_CARD
      });
    }
  };

  const {
    queryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      className: `m-left-0 ${gaClassName}`,
      onClick: toggleViewAllFeaturesModal,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: gaClassName,
        message: "pricingPage.highlightedMerchCards.seeAllFeatures"
      })
    }), isModalOpen && /*#__PURE__*/_jsx(SuiteCatalogModal, {
      initialProductLevel: productLevel,
      queryParamTerm: queryParamTerm,
      onCloseClick: toggleViewAllFeaturesModal,
      currencyCode: currencyCode
    })]
  });
};

SuiteViewAllFeatures.propTypes = {
  productLevel: PropTypes.string,
  currencyCode: PropTypes.string
};
export default SuiteViewAllFeatures;